import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import {
  isMessageTooLong,
  MESSAGING_CONTENT_LIMIT,
  showsMessageLengthCounter,
} from '~pages/Messages/messagingContentLimit';
import { MESSAGING_LABEL_FONT_WEIGHT } from '~pages/Messages/messagingTypography';

export default function MessageLengthHint({ content }: { content: string }) {
  const theme = useTheme();

  if (!showsMessageLengthCounter(content)) {
    return null;
  }

  const isTooLong = isMessageTooLong(content);
  const color = isTooLong ? theme.semantic.errorText : theme.semantic.textSecondary;

  return (
    <Box
      data-test-id="messaging-length-hint"
      sx={{ alignItems: 'center', display: 'flex', gap: 1, pt: 0.5 }}
    >
      {isTooLong && (
        <Typography
          role="alert"
          sx={{ color, fontWeight: MESSAGING_LABEL_FONT_WEIGHT }}
          variant="caption"
        >
          {t('messaging.message_too_long')}
        </Typography>
      )}

      <Typography
        data-test-id="messaging-length-counter"
        sx={{
          color,
          fontVariantNumeric: 'tabular-nums',
          fontWeight: MESSAGING_LABEL_FONT_WEIGHT,
          ml: 'auto',
        }}
        variant="caption"
      >
        {t('messaging.message_length', {
          length: content.length.toLocaleString(),
          limit: MESSAGING_CONTENT_LIMIT.toLocaleString(),
        })}
      </Typography>
    </Box>
  );
}
